import ManageTeam from './ManageTeam'

export default ManageTeam
